import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
	selector: "app-record-sound",
	templateUrl: "./record-sound.component.html",
	styleUrls: ["./record-sound.component.css"],
})
export class RecordSoundComponent implements OnInit {
	constructor(public ref: DynamicDialogRef, private dialogConfig: DynamicDialogConfig) {}

	ngOnInit(): void {}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	SoundName: any = "";

	IsRecording: any = false;

	mediaRecorder: any;
	audioChunks: any;

	errorMessage: any;

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////
	onRecord() {
		this.errorMessage = "";

		try {
			//Get info from user's microphone and turn into data stream
			navigator.mediaDevices
				.getUserMedia({ audio: true })
				.then((stream) => {
					//Switch Button
					this.IsRecording = true;

					//Create Media Recorder
					this.mediaRecorder = new MediaRecorder(stream);

					//Start Recording
					this.mediaRecorder.start();

					//Init array of audio chunks
					this.audioChunks = [];

					this.mediaRecorder.addEventListener("dataavailable", (event) => {
						try {
							this.audioChunks.push(event.data);
						} catch (e) {
							e.toString();
							this.errorMessage = "ERROR: Could not connect to microphone";
						}
					});
				})
				.catch((e) => {
					e.toString();
					this.errorMessage = "ERROR: Could not connect to microphone";
				});
		} catch (e) {
			e.toString();
			this.errorMessage = "ERROR: Could not connect to microphone";
		}
	}

	onPause() {
		this.errorMessage = "";

		this.mediaRecorder.pause();

		this.mediaRecorder.removeEventListener("dataavailable", (event) => {
			this.audioChunks.push(event.data);
		});

		this.IsRecording = false;
	}

	onStop() {
		this.errorMessage = "";
	}

	onReplay() {
		this.errorMessage = "";
	}

	onClose() {
		this.ref.close(0);
	}

	////////////////////////////////////////////
}
